var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55078 4C5.55078 2.20507 7.00586 0.75 8.80078 0.75H28.8008C28.986 0.75 29.1637 0.823595 29.2947 0.954595L42.2462 13.9061C42.3772 14.0371 42.4508 14.2147 42.4508 14.4V44C42.4508 45.7949 40.9957 47.25 39.2008 47.25H8.80078C7.00585 47.25 5.55078 45.7949 5.55078 44V4Z",
    stroke: "#D0D5DD",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8008 0.599609V10.3996C28.8008 12.6087 30.5916 14.3996 32.8008 14.3996H42.6008",
    stroke: "#D0D5DD",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 28.8008H33M15 24.3008H19.5M28.5 24.3008H33M15 33.3008H19.5M28.5 33.3008H33M19.5 37.8008V19.8008M28.5 37.8008V19.8008M19.32 37.8008H28.68C30.1921 37.8008 30.9482 37.8008 31.5258 37.5065C32.0338 37.2476 32.4469 36.8346 32.7057 36.3266C33 35.749 33 34.9929 33 33.4808V24.1208C33 22.6086 33 21.8526 32.7057 21.275C32.4469 20.767 32.0338 20.3539 31.5258 20.0951C30.9482 19.8008 30.1921 19.8008 28.68 19.8008H19.32C17.8079 19.8008 17.0518 19.8008 16.4742 20.0951C15.9662 20.3539 15.5531 20.767 15.2943 21.275C15 21.8526 15 22.6086 15 24.1208V33.4808C15 34.9929 15 35.749 15.2943 36.3266C15.5531 36.8346 15.9662 37.2476 16.4742 37.5065C17.0518 37.8008 17.8079 37.8008 19.32 37.8008Z",
    stroke: "#425466",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileVideoIcon);
export default __webpack_public_path__ + "static/media/file-video-icon.55453a17a0f58cd6b307146536021ac1.svg";
export { ForwardRef as ReactComponent };